export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var AllowPolicy;
(function (AllowPolicy) {
    AllowPolicy["UNKNOWN"] = "UNKNOWN";
    AllowPolicy["OWNER_AND_ADMINS"] = "OWNER_AND_ADMINS";
    AllowPolicy["OWNER"] = "OWNER";
    AllowPolicy["ALL_MEMBERS"] = "ALL_MEMBERS";
})(AllowPolicy || (AllowPolicy = {}));
export var StepKey;
(function (StepKey) {
    StepKey["UNKNOWN"] = "UNKNOWN";
    StepKey["CREATE_POST"] = "CREATE_POST";
    StepKey["REACT_TO_POST"] = "REACT_TO_POST";
    StepKey["INVITE_MEMBERS"] = "INVITE_MEMBERS";
})(StepKey || (StepKey = {}));
export var PrivacyStatus;
(function (PrivacyStatus) {
    PrivacyStatus["UNKNOWN"] = "UNKNOWN";
    /** Anyone can see the group in the group list and view its content. Anyone can join. */
    PrivacyStatus["PUBLIC"] = "PUBLIC";
    /** Anyone can see the group in the group list, but only group members can see its content. In order to join a group, a group join request must be submitted. */
    PrivacyStatus["PRIVATE"] = "PRIVATE";
    /** Only group members and admins can see the group in the group list. New group members can only be added by existing group members. */
    PrivacyStatus["SECRET"] = "SECRET";
})(PrivacyStatus || (PrivacyStatus = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["USER"] = "USER";
    IdentityType["MEMBER"] = "MEMBER";
})(IdentityType || (IdentityType = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** Cancelled request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
    /** Canceled request. */
    RequestStatus["CANCELED"] = "CANCELED";
})(RequestStatus || (RequestStatus = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map